import RankSelectPlatformRow from 'components/rank/RankSelectPlatformRow';
import RankTable from 'components/rank/RankTable';
import TableHeader from 'components/TableHeader';
import usePageScroll from 'hooks/usePageScroll';
import { useEffect } from 'react';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import { Background, BackgroundWrapper } from 'styles/styled-components/section';

const Rank = () => {
	const { is_scroll, setIsScroll, setCommonFilter } = useCommonStore();

	const bg_ref = usePageScroll();

	useEffect(() => {
		setCommonFilter('order_by', 'random');
		setCommonFilter('order', 'desc');
	}, []);

	return (
		<BackgroundWrapper>
			<Background
				ref={bg_ref}
				onScroll={() => {
					if (!is_scroll) setIsScroll(true);
				}}
			>
				<RankSelectPlatformRow bg_dom={bg_ref.current} />

				<TableHeader sticky_top="65px" />
				<RankTable />
				<TablePaddingBottom />
			</Background>
		</BackgroundWrapper>
	);
};

const TablePaddingBottom = styled.div`
	width: 100%;
	height: 32px;
	border-radius: 0 0 16px 16px;
	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};

	position: sticky;
	left: 0;
`;

export default Rank;
